export const speakersApi = {
  speakers: {
    queryKey: (params?: string[]) => ["speakers", ...(params || [])],
    route: () => `speakers`,
    methods: ["GET", "POST"],
  },
  speaker: {
    queryKey: (id: number, params?: string[]) => [
      "speakers",
      id,
      ...(params || []),
    ],
    route: (id: number) => `speakers/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
